
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/sbsplay",
      function () {
        return require("private-next-pages/m/sbsplay/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/sbsplay"])
      });
    }
  